import Image from 'next/image';

import { Container } from '@/components/LandingPage/Container';
import { SectionHeading } from '@/components/LandingPage/SectionHeading';
import nationalLibImage from '@/images/resources/bn.png';
import reviewsImage from '@/images/resources/review.jpg';
import bookmarkImage from '@/images/resources/bookmark.jpeg';

const resources = [
  {
    title: 'Biblioteka Narodowa',
    description:
      'Moduł katalogowania używa danych bibliograficznych, które przygotowane są w profesjonalny sposób.',
    image: function VideoPlayerImage() {
      return (
        <div className="absolute inset-0 flex items-center justify-center">
          <Image
            className="absolute inset-0 h-full w-full object-cover"
            src={nationalLibImage}
            alt=""
            sizes="(min-width: 1280px) 21rem, (min-width: 1024px) 33vw, (min-width: 768px) 19rem, (min-width: 640px) 50vw, 100vw"
          />
        </div>
      );
    },
  },
  {
    title: 'Recenzje',
    description:
      'Możesz dodawać recenzje publiczne lub prywatne - widoczne tylko dla ludzi, którzy zeskanują kod QR.',
    image: function Reviews() {
      return (
        <div className="absolute inset-0 flex items-center justify-center bg-[#6366F1]">
          <Image src={reviewsImage} alt="" unoptimized fill className="object-cover" />
        </div>
      );
    },
  },
  {
    title: 'Zakładki',
    description: 'Zakładki z kodem QR prowadzą do zawartości Twojej biblioteczki.',
    image: function BookmarkImage() {
      return (
        <div className="absolute inset-0 flex items-center justify-center bg-[radial-gradient(#2C313D_35%,#000)] object-cover">
          <Image src={bookmarkImage} alt="" unoptimized fill className="object-cover" />
        </div>
      );
    },
  },
];

export function Resources() {
  return (
    <section
      id="resources"
      aria-labelledby="resources-title"
      className="scroll-mt-14 py-16 sm:scroll-mt-32 sm:py-20 lg:py-32"
    >
      <Container>
        <SectionHeading number="3" id="resources-title">
          Możliwości
        </SectionHeading>
        <p className="mt-8 font-display text-4xl font-bold tracking-tight text-slate-900">
          Profesjonalizm w czystej postaci.
        </p>
        <p className="mt-4 text-lg tracking-tight text-slate-700">
          Używaj katalogu Biblioteki Narodowej i kataloguj błyskawicznie nowe tytuły, dodawaj
          recenzje.
        </p>
      </Container>
      <Container size="lg" className="mt-16">
        <ol
          role="list"
          className="-mx-3 grid grid-cols-1 gap-y-10 lg:grid-cols-3 lg:text-center xl:-mx-12 xl:divide-x xl:divide-slate-400/20"
        >
          {resources.map((resource) => (
            <li
              key={resource.title}
              className="grid auto-rows-min grid-cols-1 items-center gap-8 px-3 sm:grid-cols-2 sm:gap-y-10 lg:grid-cols-1 xl:px-12"
            >
              <div className="relative h-48 overflow-hidden rounded-2xl shadow-lg sm:h-60 lg:h-44">
                <resource.image />
              </div>
              <div>
                <h3 className="text-base font-medium tracking-tight text-slate-900">
                  {resource.title}
                </h3>
                <p className="mt-2 text-sm text-slate-600">{resource.description}</p>
              </div>
            </li>
          ))}
        </ol>
      </Container>
    </section>
  );
}
